import ChatScreen from "components/ChatScreen";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";

const MessagingSystem = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ChatScreen />
    </DashboardLayout>
  );
};

export default MessagingSystem;
